import React, { useState, useRef, useEffect } from "react";
import { Empty, Button, Checkbox, Select, Input } from "antd";
import { useNavigate } from "react-router-dom";

import "./TableSelectable.scss";
import useQCEStore from "../../store/qce.store";
import useJDStore from "../../store/jd.store";

export default function EvaluationSettingTable({
  isClickable = false,
  titleList,
  data,
  isEditField = true,
  config,
  handleSkillUpdate,
}) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [currentData, setCurrentData] = useState([...(data || [])]);
  const [newSkillAdded, setNewSkillAdded] = useState(false);
  const [skillRemoved, setSkillRemoved] = useState(false);

  const ResetCheckBox = () => {
    var checkBoxResetArray = data?.map((item, idx) => {
      return {
        select: "",
        id: idx,
        skill: item.skill,
        assessmenttype: item.assessmenttype,
        difficultylevel: item.difficultylevel,
        noofquestions: item.noofquestions,
        weightage: item.weightage,
        passingmarks: item.passingmarks,
        isSelected: false,
      };
    });
    setCheckBoxData(() => [...checkBoxResetArray]);
  };

  useEffect(() => {
    const checkBoxArray = data?.map((item, idx) => {
      return {
        select: "",
        id: idx,
        skill: item.skill,
        assessmenttype: item.assessmenttype,
        difficultylevel: item.difficultylevel,
        noofquestions: item.noofquestions,
        weightage: item.weightage,
        passingmarks: item.passingmarks,
        isSelected: false,
      };
    });
    setCheckBoxData([...(checkBoxArray || [])]);
    setCurrentData([...(data || [])]);
  }, [data]);

  if (!data) {
    // return <Empty style={{ margin: "60px" }} />;
  }

  function enableDbUpdate() {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      if (checkBoxData[idx].isSelected) {
        return true;
      }
    }
    return false;
  }
  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      checkBoxData[e.target.value].isSelected = true;
    } else {
      checkBoxData[e.target.value].isSelected = false;
    }
    if (enableDbUpdate() == true) {
      setUpdateAvailable(true);
    } else {
      setUpdateAvailable(false);
    }
    setCheckBoxData(() => [...checkBoxData]);
  };

  const OnSelectChange = (value, field) => {
    const answer_array = value.split("#");
    var val = answer_array[1];
    var idx = answer_array[0];
    var idxInt = parseInt(idx);
    const updatedValues = [...checkBoxData];

    if (field === "assessmenttype") {
      updatedValues[idxInt] = {
        ...updatedValues[idxInt],
        ["assessmenttype"]: val,
      };
    } else if (field === "weightage") {
      updatedValues[idxInt] = {
        ...updatedValues[idxInt],
        ["weightage"]: val === "Mandatory" ? 1 : 0,
      };
    } else if (field === "difficultylevel") {
      updatedValues[idxInt] = {
        ...updatedValues[idxInt],
        ["difficultylevel"]: val,
      };
    }
    console.log("updatedValues in OnSelectChange", updatedValues);
    setCheckBoxData(updatedValues);
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValues = [...checkBoxData];
    updatedValues[index] = { ...updatedValues[index], [name]: value };
    setCheckBoxData(updatedValues);
  };

  const encodeJson = (updateType) => {
    let encodedJsonValues = {};
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    //now fill the parameters
    encodedJsonValues.skillarray = [];

    var num = 0;
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      //console.log("checkBoxData", idx,checkBoxData[idx])
      if (checkBoxData[idx].isSelected && updateType == "UPDATE") {
        encodedJsonValues.action = "UPDATE";
        encodedJsonValues.skillarray[num] = {};
        encodedJsonValues.skillarray[num].skillid = idx;
        encodedJsonValues.skillarray[num].skill = checkBoxData[idx].skill;
        encodedJsonValues.skillarray[num].assessmenttype =
          checkBoxData[idx].assessmenttype;
        encodedJsonValues.skillarray[num].difficultylevel =
          checkBoxData[idx].difficultylevel;
        encodedJsonValues.skillarray[num].noofquestions =
          checkBoxData[idx].noofquestions;
        encodedJsonValues.skillarray[num].weightage =
          checkBoxData[idx].weightage;

        encodedJsonValues.skillarray[num].weightage =
          checkBoxData[idx].weightage;

        encodedJsonValues.skillarray[num].passingmarks =
          checkBoxData[idx].passingmarks;
        num++;
      } else if (checkBoxData[idx].isSelected && updateType == "DELETE") {
        encodedJsonValues.action = "DELETE";
        encodedJsonValues.skillarray[num] = {};
        encodedJsonValues.skillarray[num].skillid = idx;
        encodedJsonValues.skillarray[num].skill = checkBoxData[idx].skill;
        num++;
      }
    }
    if (updateType == "ADD") {
      var idx = checkBoxData.length - 1;
      num = 0;
      encodedJsonValues.action = "ADD";
      encodedJsonValues.skillarray[num] = {};
      encodedJsonValues.skillarray[num].skillid = idx;
      encodedJsonValues.skillarray[num].skill = checkBoxData[idx].skill;
      encodedJsonValues.skillarray[num].assessmenttype =
        checkBoxData[idx].assessmenttype;
      encodedJsonValues.skillarray[num].difficultylevel =
        checkBoxData[idx].difficultylevel;
      encodedJsonValues.skillarray[num].noofquestions =
        checkBoxData[idx].noofquestions;
      encodedJsonValues.skillarray[num].weightage = checkBoxData[idx].weightage;
      encodedJsonValues.skillarray[num].weightage = 1;
      encodedJsonValues.skillarray[num].passingmarks =
        checkBoxData[idx].passingmarks;
    }
    //get the current date
    let newDate = getTimeNow();
    encodedJsonValues.updatetype = updateType;
    encodedJsonValues.updatedby = userData.qhuid;
    encodedJsonValues.updatedbyname = userData.username;
    encodedJsonValues.updatedon = newDate;

    console.log(
      "encodedJsonValues in setting table encodeJson function",
      encodedJsonValues,
    );
    return encodedJsonValues;
  };

  const handleEvalCancel = (value) => {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      checkBoxData[idx].isSelected = false;
    }
    setCheckBoxData(() => [...checkBoxData]);
    setUpdateAvailable(false);
  };

  const handleEvalSave = (value) => {
    var jasonValues = encodeJson("UPDATE");
    handleSkillUpdate(jasonValues, "UPDATE");
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      checkBoxData[idx].isSelected = false;
    }
    setCheckBoxData(() => [...checkBoxData]);
    setUpdateAvailable(false);
  };

  const handleRemove = (value) => {
    //please remember ...did only to rerender the table. If we do
    setSkillRemoved(true);
    setUpdateAvailable(false);
  };
  const handleAddItem = () => {
    const newItemC = {
      select: "",
      id: checkBoxData.length,
      skill: "Please Add",
      assessmenttype: "Domain",
      difficultylevel: "Expert",
      noofquestions: 5,
      weightage: 1,
      passingmarks: 4,
    };
    const newItem = {
      select: "",
      id: checkBoxData.length,
      skill: "Please Add",
      assessmenttype: "Domain",
      difficultylevel: "Expert",
      noofquestions: 5,
      weightage: 1,
      passingmarks: 4,
      isSelected: false,
    };
    console.log("adding new item", newItemC);
    console.log("adding new item to checkbox", newItem);
    setCurrentData([...currentData, newItemC]);
    setCheckBoxData([...checkBoxData, newItem]);

    //please remember ...did only to rerender the table. If we do
    setNewSkillAdded(true);
  };

  function handleNewSkillAdded() {
    var jasonValues = encodeJson("ADD");
    handleSkillUpdate(jasonValues, "ADD");
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      checkBoxData[idx].isSelected = false;
    }
    setNewSkillAdded(false);
  }

  function handleSkillRemoved() {
    var jasonValues = encodeJson("DELETE");
    handleSkillUpdate(jasonValues, "DELETE");
    var tmp = checkBoxData;
    var tmpData = currentData;
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      if (checkBoxData[idx].isSelected == true) {
        tmp = tmp.filter((item) => item.id != idx);
        tmpData = tmpData.filter((item) => item.id != idx);
      }
      checkBoxData[idx].isSelected = false;
    }
    //reset the ids
    for (let idx = 0; idx < tmp.length; idx++) {
      tmp[idx].id = idx;
      tmpData[idx.id] = idx;
    }

    setCheckBoxData([...tmp]);
    setCurrentData([...tmpData]);
    setSkillRemoved(false);
  }

  return (
    <div className="evaluation-Setting-table-wrapper">
      <div className="rtable-selectable-btn-wrapper">
        <Button className="rtable-selectable-btn" onClick={handleAddItem}>
          Add New Skill
        </Button>
      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: config,
        }}
      >
        {titleList.map((title) => (
          <div className="rtable-title">{title}</div>
        ))}
      </div>
      {currentData?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: config,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div className="rtable-info">
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}

                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "noofquestions" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="noofquestions"
                            value={checkBoxData[rowIndex]?.noofquestions}
                            placeholder={checkBoxData[rowIndex]?.noofquestions}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          checkBoxData[rowIndex]?.noofquestions
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "passingmarks" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            type="number"
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="passingmarks"
                            value={checkBoxData[rowIndex]?.passingmarks}
                            placeholder={checkBoxData[rowIndex]?.passingmarks}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          checkBoxData[rowIndex]?.passingmarks
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "skill" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="skill"
                            value={checkBoxData[rowIndex]?.skill}
                            placeholder={checkBoxData[rowIndex]?.skill}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          checkBoxData[rowIndex]?.skill
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "assessmenttype" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="assessmenttype"
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo);
                            }}
                            placeholder={checkBoxData[rowIndex].assessmenttype}
                            value={checkBoxData[rowIndex].assessmenttype}
                            options={[
                              {
                                value: rowIndex + "#" + "Domain",
                                label: "Domain",
                              },
                              {
                                value: rowIndex + "#" + "Prog Language",
                                label: "Prog Language",
                              },
                              {
                                value: rowIndex + "#" + "Role",
                                label: "Role",
                              },
                              {
                                value: rowIndex + "#" + "Tools",
                                label: "Tools",
                              },
                              {
                                value: rowIndex + "#" + "Framework",
                                label: "Framework",
                              },
                              {
                                value: rowIndex + "#" + "Platform",
                                label: "Platform",
                              },
                            ]}
                          />
                        ) : (
                          <>{checkBoxData?.[rowIndex]?.assessmenttype}</>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "weightage" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo);
                            }}
                            placeholder={checkBoxData[rowIndex].weightage}
                            value={
                              checkBoxData[rowIndex].weightage === 1
                                ? rowIndex + "#" + "Mandatory"
                                : rowIndex + "#" + "Optional"
                            }
                            options={[
                              {
                                value: rowIndex + "#" + "Mandatory",
                                label: "Mandatory",
                              },
                              {
                                value: rowIndex + "#" + "Optional",
                                label: "Optional",
                              },
                            ]}
                          />
                        ) : (
                          checkBoxData[rowIndex]?.weightage
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "difficultylevel" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo);
                            }}
                            placeholder={checkBoxData[rowIndex].difficultylevel}
                            value={checkBoxData[rowIndex].difficultylevel}
                            options={[
                              {
                                value: rowIndex + "#" + "Easy",
                                label: "Easy",
                              },
                              {
                                value: rowIndex + "#" + "Intermediate",
                                label: "Intermediate",
                              },
                              {
                                value: rowIndex + "#" + "Expert",
                                label: "Expert",
                              },
                            ]}
                          />
                        ) : (
                          checkBoxData[rowIndex]?.difficultylevel
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
      <div
        className="rtable-selectable-btn-wrapper"
        style={{ marginTop: "10px" }}
      >
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleEvalSave}
        >
          Save Changes
        </Button>
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleRemove}
        >
          Remove Skill
        </Button>
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleEvalCancel}
        >
          Cancel Selection
        </Button>
      </div>
      {newSkillAdded ? handleNewSkillAdded() : <></>}
      {skillRemoved ? handleSkillRemoved() : <></>}
    </div>
  );
}
